import { ContainerBody } from "../../../App";
import { Back2 } from "../../../components/Option/Back";

export const ActionPlansContainer = ({ children }) => {
  return (
    <ContainerBody className="ambition__body">
      <div
        className="companydetail__wrapper2"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
          height: "0",
        }}
      >
        <Back2
          header={"Back to Ambition Page"}
          style={{ marginRight: "auto", position: "relative", left: "-7%" }}
          to={"/ambition"}
        />
      </div>
      {children}
    </ContainerBody>
  );
};
